import React from 'react'
import { privacy_policy } from 'utils/constants/privacy_policy'

function PrivacyPolicy() {
    return (
        <section>
            <div className='max-w-main py-4 sm:py-8 space-y-4 sm:space-y-8'>
                <div className='space-y-2 sm:space-y-4'>
                    <h1 className='text-2xl lg:text-4xl leading-normal font-bold'>Privacy Policy</h1>
                    <p className='text-sm sm:text-base'>Updated on 24 October 2023</p>
                </div>
                {privacy_policy.map((item, i) => (
                    <div className='space-y-2 sm:space-y-4'>
                        {item?.title && (
                            <p className='text-lg sm:text-xl font-bold'>{item.title}</p>
                        )}
                        {item?.description && (
                            <div className='space-y-2 sm:space-y-4 text-sm sm:text-base'>
                                {item.description}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    )
}

export default PrivacyPolicy